@import "../../../globals/scss/input";

$container-padding-vertical: 11px; // results in 48px ($interaction-element-height)
$space-before-container-text: $space-before-text + $container-padding-horizontal;
$border-width: 1px;
$margin-inline: $baseline-4 - 5px; // -5px fine adjustment

.component {
  cursor: pointer;
}

:host {
  display: inline-block; // "inline-*" to prevent clickable area width of 100%
  max-width: 100%; // IE11: make sure content does break and not overflow (e.g. "description")

  .component {
    --box-shadow-color: transparent;
    display: flex;
    flex-flow: column; // display validation-message below

    input {
      &:disabled {
        + label {
          ::slotted([slot="description"]) {
            color: $color-input-item-disabled;
          }
        }
      }
    }

    label {
      ::slotted([slot="description"]) {
        @include font-semi-light;
        @include text-small;
        display: block;
        letter-spacing: 0;
        padding-top: 5px;
        padding-bottom: 3px; // together with padding-top, fits into 8px-grid
        color: $color-checkbox-supporting;
      }
    }
  }
}

// Safari 14 CSS specificity fix:
// :host(.class) selector needs to be *below* the general :host selector
:host(.input-container) {
  display: block; // act like a <div>

  .component {
    &.inline {
      height: 100%;
    }

    &:hover {
      input:not(:disabled) {
        &.focus,
        &:checked {
          + label {
            --box-shadow-color: #{$color-checkbox-fill-hover};
            border-color: $color-checkbox-fill-hover;
          }
        }

        &:checked {
          + label {
            .icon {
              color: $color-checkbox-fill-hover;
            }
          }
        }

        + label {
          --box-shadow-color: #{$color-input-normal-form-hover};
          border-color: $color-input-normal-form-hover;

          .icon {
            color: $color-input-normal-form-hover;
          }
        }
      }
    }

    input {
      &.focus,
      &:checked {
        + label {
          border-color: $color-checkbox-fill;
        }
      }

      &:checked {
        // When there's no icon emphasizing "selected", color the label instead
        &.hide-checked-icon {
          + label {
            color: $color-checkbox-fill;
          }
        }

        + label {
          --box-shadow-color: #{$color-checkbox-fill};

          .icon {
            color: $color-checkbox-fill;
          }
        }
      }

      &:disabled {
        + label {
          border-color: $color-input-item-disabled;
          color: $color-input-item-disabled;

          .icon {
            color: $color-input-item-disabled;
          }
        }
      }

      &.hide-checked-icon {
        + label {
          padding-left: $container-padding-horizontal;
          box-shadow: inset 0 0 0 $border-width var(--box-shadow-color);

          &::before,
          &::after {
            display: none;
          }
        }
      }
    }

    label {
      border: $border-width solid $color-checkbox-supporting;
      border-radius: $border-radius-medium;
      padding: $container-padding-vertical $container-padding-horizontal;
      padding-left: $space-before-container-text;
      transition: border-color 200ms $standard-easing,
        box-shadow 200ms $standard-easing, color 200ms $standard-easing;

      &::before,
      &::after {
        margin: $container-padding-vertical + 1px; // + 1px: the checked icons should look centered when height is 48px ($interaction-element-height)
      }

      .icon-placeholder {
        margin-top: $baseline - 2px; // 2px fine adjustment
        visibility: hidden;
      }

      .icon {
        position: absolute;
        bottom: $container-padding-horizontal;
        left: 0;
        right: 0;
        text-align: center;
        transition: color 200ms $standard-easing;
        color: $color-checkbox-empty;
      }
    }
  }
}

:host(.sdx--dark-theme) {
  .component {
    input {
      &:disabled {
        + label {
          ::slotted([slot="description"]) {
            color: $color-disabled-dark-theme;
          }
        }
      }

      + label {
        ::slotted([slot="description"]) {
          color: $color-int-gray-dark-theme;
        }
      }
    }
  }
}

:host(.input-container.sdx--dark-theme) {
  .component {
    &:hover {
      input:not(:disabled) {
        &.focus,
        &:checked {
          + label {
            --box-shadow-color: #{$color-int-blue2-dark-theme--active};
            border-color: $color-int-blue2-dark-theme--active;
          }
        }

        &:checked {
          + label {
            .icon {
              color: $color-int-blue2-dark-theme--active;
            }
          }
        }

        + label {
          --box-shadow-color: #{$color-int-gray-dark-theme--active};
          border-color: $color-int-gray-dark-theme--active;

          .icon {
            color: $color-int-gray-dark-theme--active;
          }
        }
      }
    }

    input {
      &.focus,
      &:checked {
        + label {
          border-color: $color-int-blue2-dark-theme;
        }
      }

      &:checked {
        &.hide-checked-icon {
          + label {
            color: $color-int-blue2-dark-theme;
          }
        }

        + label {
          --box-shadow-color: #{$color-int-blue2-dark-theme};

          .icon {
            color: $color-int-blue2-dark-theme;
          }
        }
      }

      &:disabled {
        + label {
          border-color: $color-disabled-dark-theme;
          color: $color-disabled-dark-theme;

          .icon {
            color: $color-disabled-dark-theme;
          }
        }
      }
    }

    label {
      border-color: $color-int-gray-dark-theme--active;

      .icon {
        color: $color-int-gray-dark-theme;
      }
    }
  }
}
